module.exports = "https://static.im-cdn.com/mjc/storefront/Accent/static/media/Facebook.586fdd05.svg";